import Navbar from '../NavBar';
import { useLocation } from 'react-router-dom';
import { useState, useEffect, Suspense, lazy } from 'react';
import "./header.scss";
import '../home/section-connector.scss';
import './header-connector.scss';

const NewsCarousel = lazy(() => import('../carousel/NewsCarousel'));

function Header(props) {
    const [isNavbarExpanded, setIsNavbarExpanded] = useState(false);
    const location = useLocation();
    // State for news items (homepage only); undefined means use NewsCarousel defaults
    const [newsItems, setNewsItems] = useState(undefined);

    // Listen for navbar collapse/expand events
    useEffect(() => {
        const navbarCollapse = document.getElementById('navbarNav');
        if (navbarCollapse) {
            const observer = new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                    if (mutation.attributeName === 'class') {
                        const isExpanded = navbarCollapse.classList.contains('show');
                        setIsNavbarExpanded(isExpanded);
                    }
                });
            });
            observer.observe(navbarCollapse, { attributes: true });
            return () => observer.disconnect();
        }
    }, []);

    // Fetch news items at runtime (homepage only)
    useEffect(() => {
        if (location.pathname === '/') {
            fetch('/news-items.json', { cache: 'no-store' })
                .then(res => {
                    if (!res.ok) throw new Error('Network response was not ok');
                    return res.json();
                })
                .then(data => {
                    if (Array.isArray(data) && data.length > 0 && data.every(item => item.title && item.description)) {
                        setNewsItems(data);
                    } else {
                        setNewsItems(undefined); // Use NewsCarousel defaults
                    }
                })
                .catch(() => {
                    setNewsItems(undefined); // Use NewsCarousel defaults
                });
        }
    }, [location.pathname]);

    // Determine header background class
    let headerBgClass;
    switch (location.pathname) {
        case '/':
            headerBgClass = 'main-header';
            break;
        case '/about':
        case '/consulting':
        case '/altova':
            headerBgClass = 'about-header';
            break;
        case '/edtech':
            headerBgClass = 'edtech-header';
            break;
        default:
            headerBgClass = 'training-header';
    }

    return (
        <>
            <div className={`fluid-container header-wrapper ${headerBgClass} ${isNavbarExpanded ? 'navbar-expanded' : ''}`}>
                <Navbar onNavbarToggle={setIsNavbarExpanded} />
                <div className="header-content">
                    <div className="row">
                        <div className={`${location.pathname === '/' ? 'col-12 col-md-6' : 'col-12 col-md-8'}`}>
                            <div className="row header-title-row">
                                <div className="col-12 header-title" dangerouslySetInnerHTML={{ __html: props.title }}/>
                            </div>
                            <div className="row header-strap-row">
                                <div className="col-12 header-strap" dangerouslySetInnerHTML={{ __html: props.strapline }}/>
                            </div>
                        </div>
                        {location.pathname === '/' && (
                            <div className="col-12 col-md-6 header-carousel-container">
                                <Suspense fallback={<div className="carousel-loading">Loading news...</div>}>
                                    <NewsCarousel newsItems={newsItems} />
                                </Suspense>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {/* Add zigzag connector only on the homepage - matching other section connectors */}
            {location.pathname === '/' && (
                <div className="section-connector zigzag-right header-connector">
                    {/* Arrow head removed */}
                </div>
            )}
        </>
    );
}

export default Header;